import { Scalars } from '@generated/base-types';
import { ManagerError } from '@new/common/utils/error-parser';
import { Exam } from '../../../lib/types';

export class LoadExam {
  public static readonly type = '[Exam] Load';
  constructor(public readonly id: Scalars['ID']) {}
}

export class LoadExamSuccess {
  public static readonly type = '[Exam] Load success';
  constructor(public readonly exam: Exam) {}
}

export class LoadExamFailure {
  public static readonly type = '[Exam] Load failure';
  constructor(
    public readonly error: ManagerError,
    public readonly id: Scalars['ID']
  ) {}
}
